import React, { useEffect, useState } from "react";
import './SegmentedToggle.scss';
import { Button, ButtonGroup } from "@progress/kendo-react-buttons";
import { IElementType } from "./types";

interface ISegmentedToggleProps {
    label?: string;
    element: IElementType;
    group?: string | null;
    value: boolean;
    offLabel: string;
    onLabel: string;
    readOnly?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFunction: (args: any) => any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    saveFunction: (element?: IElementType, group?: string | null) => any;
}

export const SegmentedToggle = ({ label, element, group, value, offLabel, onLabel, readOnly, setFunction, saveFunction }: ISegmentedToggleProps) => {
    const [changed, setChanged] = useState<boolean>(false);

    const handleSelect = (selected: boolean) => {
        if (selected === value) return;
        setFunction({ group, element, value: selected });
        setChanged(true);
    };

    // The save reads the options off the store, so it has to wait for the new value to land there -
    // called alongside the change it would write back the one being replaced.
    useEffect(() => {
        if (changed) {
            saveFunction(element, group);
            setChanged(false);
        }
    }, [value]);

    return (
        <div className={readOnly ? "segmentedToggle disabled" : "segmentedToggle"}>
            <label>{label}</label>
            {/* Read-only is the wrapper's job here rather than the buttons' own disabled prop, which
                washes the selected segment out until the two read alike. */}
            <ButtonGroup>
                <Button togglable selected={!value} onClick={() => handleSelect(false)}>{offLabel}</Button>
                <Button togglable selected={value} onClick={() => handleSelect(true)}>{onLabel}</Button>
            </ButtonGroup>
        </div>
    );
};
